import { render } from "./MPSIIIDLeukocytes.vue?vue&type=template&id=72055a24&scoped=true"
import script from "./MPSIIIDLeukocytes.vue?vue&type=script&lang=js"
export * from "./MPSIIIDLeukocytes.vue?vue&type=script&lang=js"

import "./MPSIIIDLeukocytes.vue?vue&type=style&index=0&id=72055a24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72055a24"]])

export default __exports__